/**
 * Serialize Site context for the agent API.
 * @param {object} context mounted page context
 * @return {object} public Site context
 */
export function serializeSiteContext(context) {
	const route = context.route?.toLowerCase();
	const siteId = context.site_id ?? context.siteId;
	const siteName = context.site_name ?? context.siteName;
	const hasSiteContext = [
		'/topology',
		'/accesspointdashboard',
	].includes(route) &&
		typeof siteId === 'string' &&
		Boolean(siteId);
	return {
		site_id: hasSiteContext ? siteId : null,
		site_name: hasSiteContext &&
			typeof siteName === 'string' &&
			siteName
			? siteName
			: null,
		// Which form variant the user is standing in front of. It is the
		// Site that is TIP or not, and the forms opened from a Site follow
		// it - Add Access Point asks for a MAC address on a TIP Site and a
		// serial number on a non-TIP one. Published here rather than with
		// the Access Point, which only knew it on its own dashboard, so the
		// agent could not tell the variant of a form opened from a Site.
		is_tip_enabled: hasSiteContext && context.is_tip_enabled != null
			? Number(context.is_tip_enabled) === 1
			: null,
	};
}
